import SimplePeer from "simple-peer";
import React, { useRef, useState, useEffect, useCallback } from "react";
import { InputGroup } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import useWebSocket from 'react-use-websocket';

const StreamSendComponent = () => {
  const [pc_pub, setpc_pub] = useState(null);

	const getWsUrl = useCallback(() => {
		return new Promise((resolve) => {
			setTimeout(()=>{document.getElementById('confirmBtn2').onclick = () => {
				resolve(document.getElementById('signalServer2').value);
			}}, 500)
			
		})
	}, []);
	const { sendMessage, lastMessage, lastJsonMessage, readyState } = useWebSocket(getWsUrl, {
		onOpen: () => {
      console.log('opened ws')
      sendMessage(JSON.stringify({
        type: "publish"
      }))
    },
		shouldReconnect: () => true,
	});

	useEffect(()=>{
		if (!pc_pub) return;
		let msg = lastJsonMessage;
      switch (msg.type) {
      case "start":
        start();
        break;

      case "answer":
        pc_pub.setRemoteDescription(msg).then(() => {

        }).catch((err) => {

        })
        break;

      default:
        pc_pub.addIceCandidate(msg);
        break;
    }

	}, [lastJsonMessage])
useEffect(()=>{
		const p = new RTCPeerConnection();
		setpc_pub(p);
    p.addEventListener('icecandidate', (event) => {
      if (event.candidate) {
        sendMessage(JSON.stringify(event.candidate));
      }
    })

},[])
const getDevice =() => {
  return new Promise((resolve, reject) => {
    navigator.mediaDevices.getUserMedia({ video: false, audio: {echoCancellation: false, noiseSuppression: false} }).then((mediaStream) => {
      //localVideo.srcObject = mediaStream;
      resolve(mediaStream);
    }).catch((err) => {
      reject(err);
    })
  })
}
	const start = async () => {
		if (readyState !== 1) return;
    getDevice().then((mediaStream) => {
      pc_pub.addTrack(mediaStream.getAudioTracks()[0], mediaStream);
      pc_pub.createOffer().then((offer) => {
        pc_pub.setLocalDescription(offer).then(() => {
          sendMessage(JSON.stringify(offer));
        }).catch((err) => {
          console.error('setLocalDescription error', err);
        })
      }).catch((err) => {
        console.error("create offer error", err);
      })
    }).catch((err) => {
      console.error("getDevice error", err);
    })
  
	};

  return (
    <>
      <div style={{textAlign:"center"}}>
				<InputGroup size="sm" style={{ padding: "2px" }}>
					<InputGroup.Text>Signal server</InputGroup.Text>
					<Form.Control id="signalServer2" defaultValue='ws://127.0.0.1:9000' />
				</InputGroup>

        <Button
          //variant={!binStat ? "secondary" : "primary"}
          style={{ display: "block", margin: 2 + "px" }}
          id="confirmBtn2"
        >
          Confirm
        </Button>
        <Button
          //variant={!binStat ? "secondary" : "primary"}
          style={{ display: "block", margin: 2 + "px" }}
          onClick={start}
        >
          Send
        </Button>
      </div>

    </>
  );
};

export default StreamSendComponent;
